import events from "../values/events";
import eventCategories from "../values/eventCategories";
import eventActions from "../values/eventActions";

const commonCustomTags = {
    petType: null,
    breedNames: null,
    petAge: null,
    cartLineItemId: null,
    email: null,
    zipCode: null,
};

const pageEventConfig = {
    getMyQuoteClicked: {
        event: events.FUNNEL_STEP_COMPLETE,
        eventCategory: eventCategories.FUNNEL,
        eventAction: eventActions.FUNNEL_STAGE_1,
        ...commonCustomTags,
    },
    getQuote: {
        event: events.START_QUOTE,
        eventCategory: eventCategories.START_QUOTE,
        eventAction: eventActions.CLICK,
        cartLineItemId: null,
    },
    getQuoteSubmit: {
        event: events.START_QUOTE_SUBMIT,
        failure_reason: null,
        pet_age: null,
        pet_type: null,
    },
};

export default pageEventConfig;
